<template>
  <div class="p-3">
    <h4>{{ item.name }}</h4>
  </div>
</template>

<script>
import { Contact } from "../../models/Contact";

export default {
  name: "CustomerCell",
  props: {
    item: {
      type: Contact,
      required: true
    }
  }
};
</script>

<style scoped></style>
